<nav>
    <ul>
        <li><a routerLink="about" routerLinkActive="active">About</a></li>
        <li><a href="../../assets/brochure.pdf" download>Brochure</a></li>
        <li><a routerLink="testimonials">Testimonials</a></li>
        <li><a routerLink="contact">Contact</a></li>
    </ul>
</nav>
